import { Component, Input } from '@angular/core';
import { PageRequest, SpringPage } from '@shared/page';
import { Contract } from '@shared/models/contract';
import { AdminOrganizationService } from '@shared/services/admin-organization.service';
import { ADMIN_PREFIX } from '../../../../../app-routing.constants';
import { CONTRACTS_ROUTE, ORGANIZATIONS_ROUTE } from '../../../admin-routing.module';
import { NgxDatatableModule } from '@siemens/ngx-datatable';
import { TypedTemplateDirective } from '@shared/directives/typed-template.directive';
import { RouterLink } from '@angular/router';
import { BadgeOrganizationComponent } from '@shared/components/badge-organization/badge-organization.component';
import { TablePagerComponent } from '@shared/components/table-pager/table-pager.component';
import { DatePipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-organization-contracts',
  templateUrl: './organization-contracts.component.html',
  styleUrl: './organization-contracts.component.scss',
  imports: [
    NgxDatatableModule,
    TypedTemplateDirective,
    RouterLink,
    BadgeOrganizationComponent,
    TablePagerComponent,
    DatePipe,
    TranslatePipe,
  ],
})
export class OrganizationContractsComponent {
  @Input({ required: true }) organizationCode: string;

  data: SpringPage<Contract> | undefined;
  page: PageRequest = { number: 0, size: 10 };

  rowType = { row: {} as Contract };

  constructor(private organizationService: AdminOrganizationService) {}

  ngOnInit() {
    this.refreshData();
  }

  changePage(page: number) {
    this.page = { ...this.page, number: page };
    this.refreshData();
  }

  async refreshData() {
    this.data = await this.organizationService.getOrganizationContracts(this.organizationCode, this.page);
  }

  protected readonly ADMIN_PREFIX = ADMIN_PREFIX;
  protected readonly ORGANIZATIONS_ROUTE = ORGANIZATIONS_ROUTE;
  protected readonly CONTRACTS_ROUTE = CONTRACTS_ROUTE;
}
